/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Tool Icon component.
 */
export const AssetToolIcon = ({color, size, ...props}: IconProps) => {
  const {stroke = undefined} = props;
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <ThemeIconProvider name='AssetToolIcon' size={size} color={color} {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' {...props}>
        <path d='M6.083 17.45a.278.278 0 000 .082v2.442a.545.545 0 00.553.546h5.618a.547.547 0 00.554-.546v-1.937a.546.546 0 00-.554-.546h-2.239l.464-2.922H6.547l-.464 2.882zM5.375 7A.383.383 0 005 7.375v6.236a.383.383 0 00.375.374h11.329a.5.5 0 00.5-.5V7.5a.5.5 0 00-.5-.5H5.374z'
          fill={iconColor}
          stroke={stroke} />
        <path d='M18.352 8.848l-1.433-.415v4.2l1.433-.406a.437.437 0 00.098-.074.358.358 0 00.179-.293V9.206a.374.374 0 00-.277-.358zM19.303 9.98h2.384v1.192h-2.384z'
          fill={iconColor}
          stroke={stroke} />
      </svg>
    )} />
  );
};
